import React from "react";
import SimpleBar from "simplebar-react";
import "simplebar/dist/simplebar.min.css";
import "./scrollbar.css";

const ScrollBar = ({ children, emailModal, eventModal }) => {
  return (
    <SimpleBar
      className={` ${
        eventModal
          ? "event-section"
          : emailModal
          ? "email-section"
          : "agenda-section-height"
      } m-2`}>
      {children}
    </SimpleBar>
  );
};

export default ScrollBar;
